import React, {Component, Fragment} from "react";
import {CommandBarButton,  TextField} from "office-ui-fabric-react";
import DispatchProps from "../utils/DispatchProps";
import {IRootState} from "../store";
import {connect} from "react-redux";
import H from "history";
import {Link} from "react-router-dom";


export interface ProcessorComparisionSelectorProps {
    tenantId: string;
    schoolCode: string;
    
    instanceIdA:  string;
    history: H.History;
}

export interface ProcessorComparisionSelectorState {
    instanceIdB?: string;
}

class ProcessorComparisionSelector extends Component<ProcessorComparisionSelectorProps & DispatchProps, ProcessorComparisionSelectorState> {
    static displayName = ProcessorComparisionSelector.name;
    
    constructor(props: ProcessorComparisionSelectorProps & DispatchProps) {
        super(props);

        this.state = {
            instanceIdB: undefined,
        };
    }

    public componentDidMount() {
    }
    
    public render() {
        
        return (
            <Fragment>
                <TextField
                    value={this.state.instanceIdB}
                    placeholder={"Processor id"}
                    onChange={(e,v) => {
                        this.setState({
                            instanceIdB: v
                        });
                    }}
                />
                
                <Link to={`/cdb-admin/mailroom/salamander/${this.props.tenantId}/${this.props.schoolCode}/process/${this.props.instanceIdA}/compare/${this.state.instanceIdB}`} target="_blank">
                    <CommandBarButton
                        iconProps={{ iconName: "DiffSideBySide" }}
                        text="Compare"
                    />
                </Link>
            </Fragment>
        );
    };
}

export default connect(
    (state: IRootState, ownProps: {tenantId: string,schoolCode: string, instanceIdA: string, history: H.History }): ProcessorComparisionSelectorProps => {

        return {
            tenantId: ownProps.tenantId,
            schoolCode: ownProps.schoolCode,
            
            instanceIdA: ownProps.instanceIdA,
            history: ownProps.history
        };
    }
)(ProcessorComparisionSelector)